/* ============================================================
   FUTUREDUST.CO — theme interactions
   Only the custom JS the handoff allows: carousel, overlay nav,
   cart drawer (on Shopify's Ajax cart), scroll-reveal, accordion.
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- a11y helpers: focusable query + focus trap ---------- */
  var FD_FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),textarea:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function getFocusable(container) {
    return Array.prototype.slice.call(container.querySelectorAll(FD_FOCUSABLE))
      .filter(function (el) { return el.getClientRects().length > 0; });
  }
  function createFocusTrap(getEls) {
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var els = getEls();
      if (!els.length) return;
      var idx = els.indexOf(document.activeElement);
      if (e.shiftKey) {
        if (idx <= 0) { e.preventDefault(); els[els.length - 1].focus(); }
      } else if (idx === -1 || idx === els.length - 1) { e.preventDefault(); els[0].focus(); }
    }
    document.addEventListener('keydown', onKey, true);
    return function () { document.removeEventListener('keydown', onKey, true); };
  }
  /* Focus after the panel's visibility transition has flipped (a visibility-transitioned
     element is not focusable on the same tick the class is added). */
  function deferFocus(el) {
    if (!el) return;
    requestAnimationFrame(function () { requestAnimationFrame(function () { try { el.focus(); } catch (e) {} }); });
  }

  /* ---------- horizontal swipe (touch) ---------- */
  function addSwipe(el, onNext, onPrev) {
    if (!el) return;
    var x0 = null, y0 = null, t0 = 0;
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = Date.now();
    }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Date.now() - t0 > 800) return;                 // too slow to be a swipe
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.4) return; // short or vertical
      if (dx < 0) onNext(); else onPrev();
    }, { passive: true });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-fd-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('fd-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('fd-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Hero carousel ---------- */
  function initHero() {
    var hero = document.querySelector('[data-fd-hero]');
    if (!hero) return;
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.fd-hero__slide'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('.fd-hero__dot'));
    var counter = hero.querySelector('[data-fd-hero-index]');
    var prev = hero.querySelector('[data-fd-hero-prev]');
    var next = hero.querySelector('[data-fd-hero-next]');
    if (slides.length < 2) return;
    var i = 0, timer = null, delay = 5600;

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, x) { s.classList.toggle('is-active', x === i); });
      dots.forEach(function (d, x) { var on = x === i; d.classList.toggle('is-active', on); d.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      if (counter) counter.textContent = pad(i + 1);
    }
    function start() { if (reduce) return; stop(); timer = setInterval(function () { show(i + 1); }, delay); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function goTo(n) { show(n); start(); }

    dots.forEach(function (d, x) { d.addEventListener('click', function () { goTo(x); }); });
    if (prev) prev.addEventListener('click', function () { goTo(i - 1); });
    if (next) next.addEventListener('click', function () { goTo(i + 1); });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    addSwipe(hero, function () { goTo(i + 1); }, function () { goTo(i - 1); });

    show(0);
    start();
  }

  /* ---------- Overlay nav ---------- */
  function initNav() {
    var nav = document.querySelector('[data-fd-nav]');
    var toggle = document.querySelector('[data-fd-nav-toggle]');
    if (!nav || !toggle) return;
    var label = toggle.querySelector('[data-fd-nav-label]') || toggle;
    var openLabel = toggle.getAttribute('data-open-label') || 'NAV';
    var closeLabel = toggle.getAttribute('data-close-label') || 'CLOSE ×';
    var releaseTrap = null, lastFocused = null;

    function open() {
      if (window.fdCart && window.fdCart.close) window.fdCart.close();
      lastFocused = document.activeElement;
      nav.classList.add('is-open'); nav.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      label.textContent = closeLabel;
      document.body.classList.add('fd-nav-open'); document.body.style.overflow = 'hidden';
      releaseTrap = createFocusTrap(function () { return [toggle].concat(getFocusable(nav)); });
      deferFocus(nav.querySelector('[data-fd-nav-link]'));
    }
    function close() {
      nav.classList.remove('is-open'); nav.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      label.textContent = openLabel;
      document.body.classList.remove('fd-nav-open'); document.body.style.overflow = '';
      if (releaseTrap) { releaseTrap(); releaseTrap = null; }
      if (lastFocused && lastFocused.focus) { lastFocused.focus(); lastFocused = null; }
    }
    function isOpen() { return nav.classList.contains('is-open'); }

    toggle.addEventListener('click', function () { isOpen() ? close() : open(); });
    nav.querySelectorAll('[data-fd-nav-link]').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
    window.fdNav = { close: close };
  }

  /* ---------- Cart drawer (Shopify Ajax cart) ---------- */
  function money(cents, fmt) {
    fmt = fmt || '${{amount}}';
    var value = (cents / 100);
    function fmtNum(dp, ts, ds) {
      ts = ts || ','; ds = ds || '.';
      var s = (Math.abs(value)).toFixed(dp);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.join(dp ? ds : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return fmtNum(2, ',', '.');
        case 'amount_no_decimals': return fmtNum(0);
        case 'amount_with_comma_separator': return fmtNum(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(0, '.', '');
        default: return fmtNum(2, ',', '.');
      }
    });
  }

  function initDrawer() {
    var drawer = document.querySelector('[data-fd-drawer]');
    var scrim = document.querySelector('[data-fd-scrim]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-fd-cart-open]');
    var closers = drawer.querySelectorAll('[data-fd-drawer-close]');
    var body = drawer.querySelector('[data-fd-drawer-body]');
    var foot = drawer.querySelector('[data-fd-drawer-foot]');
    var countEls = document.querySelectorAll('[data-fd-cart-count]');
    var fmt = drawer.getAttribute('data-money-format') || '${{amount}}';

    var releaseTrap = null, lastFocused = null;
    function open() {
      if (window.fdNav && window.fdNav.close) window.fdNav.close();
      lastFocused = document.activeElement;
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
      if (scrim) scrim.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
      refresh();
      releaseTrap = createFocusTrap(function () { return getFocusable(drawer); });
      deferFocus(drawer.querySelector('[data-fd-drawer-close]'));
    }
    function close() {
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
      if (scrim) scrim.classList.remove('is-open');
      document.body.style.overflow = '';
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      if (releaseTrap) { releaseTrap(); releaseTrap = null; }
      if (lastFocused && lastFocused.focus) { lastFocused.focus(); lastFocused = null; }
    }

    function setCount(n) { countEls.forEach(function (el) { el.textContent = n; }); }

    function render(cart) {
      setCount(cart.item_count);
      if (!cart.items.length) {
        body.innerHTML = '<div class="fd-drawer__empty"><p>Your cart is empty.</p><a class="fd-pill fd-pill--ghost-dark" href="/collections/store">BROWSE THE STORE</a></div>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;
      body.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img class="fd-line__img" src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="">' : '<div class="fd-line__img"></div>';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : (it.product_type || '');
        return '<div class="fd-line" data-key="' + it.key + '">' + img +
          '<div class="fd-line__main"><div class="fd-line__name">' + it.product_title + '</div>' +
          '<div class="fd-line__variant">' + variant + '</div>' +
          '<div class="fd-line__qty"><button class="fd-step" data-fd-dec aria-label="Decrease">\u2212</button>' +
          '<span class="fd-line__qv">' + it.quantity + '</span>' +
          '<button class="fd-step" data-fd-inc aria-label="Increase">+</button></div></div>' +
          '<div class="fd-line__right"><div class="fd-line__price">' + money(it.final_line_price, fmt) + '</div>' +
          '<button class="fd-line__remove" data-fd-remove>REMOVE</button></div></div>';
      }).join('');
      var sub = drawer.querySelector('[data-fd-subtotal]');
      var co = drawer.querySelector('[data-fd-checkout-total]');
      if (sub) sub.textContent = money(cart.total_price, fmt);
      if (co) co.textContent = money(cart.total_price, fmt);
    }

    function refresh() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render).catch(function () {});
    }

    function change(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(render).catch(function () {});
    }

    if (body) {
      body.addEventListener('click', function (e) {
        var row = e.target.closest('[data-key]');
        if (!row) return;
        var key = row.getAttribute('data-key');
        var qv = row.querySelector('.fd-line__qv');
        var q = parseInt(qv ? qv.textContent : '1', 10) || 1;
        if (e.target.closest('[data-fd-inc]')) change(key, q + 1);
        else if (e.target.closest('[data-fd-dec]')) change(key, Math.max(1, q - 1));
        else if (e.target.closest('[data-fd-remove]')) change(key, 0);
      });
    }

    openers.forEach(function (o) { o.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    closers.forEach(function (c) { c.addEventListener('click', close); });
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

    // Keep header count in sync on load.
    refresh();
    // Expose for add-to-cart handlers.
    window.fdCart = { open: open, close: close, refresh: refresh };
  }

  /* ---------- full cart page (/cart) ---------- */
  function initCartPage() {
    var root = document.querySelector('[data-fd-cart]');
    if (!root) return;
    var form = root.querySelector('[data-fd-cart-form]');
    var items = root.querySelector('[data-fd-cart-items]');
    var empty = root.querySelector('[data-fd-cart-empty]');
    var subEl = root.querySelector('[data-fd-cart-subtotal]');
    var countEls = document.querySelectorAll('[data-fd-cart-count]');
    var fmt = root.getAttribute('data-money-format') || '${{amount}}';
    if (!items) return;
    var busy = false;

    function setCount(n) { countEls.forEach(function (el) { el.textContent = n; }); }

    function apply(cart, key) {
      if (!cart || !cart.items) return;
      setCount(cart.item_count);
      var row = items.querySelector('[data-key="' + key + '"]');
      var it = null;
      for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].key === key) { it = cart.items[i]; break; } }
      if (!it) {
        if (row && row.parentNode) row.parentNode.removeChild(row);
      } else if (row) {
        var qv = row.querySelector('[data-fd-qv]');
        if (qv) qv.value = it.quantity;
        var lt = row.querySelector('[data-fd-line-total]');
        if (lt) lt.textContent = money(it.final_line_price, fmt);
      }
      if (subEl) subEl.textContent = money(cart.total_price, fmt) + ' ' + cart.currency;
      if (cart.item_count === 0) {
        if (form) form.classList.add('is-hidden');
        if (empty) empty.classList.remove('is-hidden');
      }
    }

    function change(key, qty) {
      if (busy) return;
      busy = true; root.setAttribute('aria-busy', 'true');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { apply(cart, key); })
        .catch(function () {})
        .then(function () {
          busy = false; root.removeAttribute('aria-busy');
          if (window.fdCart && window.fdCart.refresh) window.fdCart.refresh();
        });
    }

    items.addEventListener('click', function (e) {
      var row = e.target.closest('[data-key]');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var qv = row.querySelector('[data-fd-qv]');
      var q = parseInt(qv ? qv.value : '1', 10) || 1;
      if (e.target.closest('[data-fd-inc]')) { e.preventDefault(); change(key, q + 1); }
      else if (e.target.closest('[data-fd-dec]')) { e.preventDefault(); change(key, Math.max(1, q - 1)); }
      else if (e.target.closest('[data-fd-remove]')) { e.preventDefault(); change(key, 0); }
    });

    items.addEventListener('change', function (e) {
      var input = e.target.closest('[data-fd-qv]');
      if (!input) return;
      var row = e.target.closest('[data-key]');
      if (!row) return;
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 0;
      change(row.getAttribute('data-key'), q);
    });
  }

  /* ---------- Ajax add-to-cart (for real product tiles) ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fd-add]');
      if (!btn) return;
      var id = btn.getAttribute('data-fd-add');
      if (!id) return;
      e.preventDefault();
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      }).then(function (r) { return r.json(); }).then(function () {
        btn.disabled = false;
        if (window.fdCart) { window.fdCart.open(); }
      }).catch(function () { btn.disabled = false; });
    });
  }

  /* ---------- Accordion (product page) ---------- */
  function initAccordion() {
    document.querySelectorAll('[data-fd-accordion] [data-fd-acc-trigger]').forEach(function (t) {
      t.addEventListener('click', function () {
        var item = t.closest('[data-fd-acc-item]');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var g = document.querySelector('[data-fd-gallery]');
    if (!g) return;
    var main = g.querySelector('[data-fd-gallery-main]');
    if (!main) return;
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-fd-gallery-thumb]'));
    if (!thumbs.length) return;
    var cur = 0;
    function show(i) {
      cur = (i + thumbs.length) % thumbs.length;
      var t = thumbs[cur];
      var src = t.getAttribute('data-src');
      if (src) main.src = src;
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
    });
    if (thumbs.length > 1) {
      addSwipe(g.querySelector('.fd-pdp__main'), function () { show(cur + 1); }, function () { show(cur - 1); });
    }
  }

  /* ---------- Product form (variants, qty, add-to-cart) ---------- */
  function initProduct() {
    initGallery();
    var form = document.querySelector('[data-fd-product]');
    if (!form) return;
    var fmt = form.getAttribute('data-money-format') || '${{amount}}';
    var idInput = form.querySelector('[data-fd-variant-id]');
    var priceEl = document.querySelector('[data-fd-price]');
    var addBtn = form.querySelector('[data-fd-pdp-add]');
    var stockEl = document.querySelector('[data-fd-stock]');
    var qtyInput = form.querySelector('[data-fd-qty-val]');
    var variants = [];
    try { variants = JSON.parse(form.querySelector('[data-fd-variants]').textContent); } catch (e) {}

    function qty() { var q = parseInt(qtyInput.value, 10); return (q && q > 0) ? q : 1; }
    function currentVariant() {
      var id = parseInt(idInput.value, 10);
      for (var i = 0; i < variants.length; i++) { if (variants[i].id === id) return variants[i]; }
      return variants[0];
    }
    function selectedOptions() {
      var arr = [];
      form.querySelectorAll('[data-fd-opt].is-active').forEach(function (b) {
        arr[parseInt(b.getAttribute('data-opt-position'), 10) - 1] = b.getAttribute('data-opt-value');
      });
      return arr;
    }
    function matchVariant() {
      var sel = selectedOptions();
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options, ok = true;
        for (var p = 0; p < sel.length; p++) { if (sel[p] != null && o[p] !== sel[p]) { ok = false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }
    function updateUI() {
      var v = currentVariant();
      if (!v) return;
      if (priceEl) priceEl.textContent = money(v.price, fmt);
      if (stockEl) stockEl.textContent = v.available ? 'IN STOCK' : 'SOLD OUT';
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.classList.toggle('is-sold-out', !v.available);
        if (v.available) { addBtn.innerHTML = 'ADD TO CART — <span data-fd-total>' + money(v.price * qty(), fmt) + '</span>'; }
        else { addBtn.textContent = 'SOLD OUT'; }
      }
    }

    form.querySelectorAll('[data-fd-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.getAttribute('data-opt-position');
        form.querySelectorAll('[data-fd-opt][data-opt-position="' + pos + '"]').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
        var v = matchVariant();
        if (v) idInput.value = v.id;
        updateUI();
      });
    });
    var dec = form.querySelector('[data-fd-qty-dec]'), inc = form.querySelector('[data-fd-qty-inc]');
    if (dec) dec.addEventListener('click', function () { qtyInput.value = Math.max(1, qty() - 1); updateUI(); });
    if (inc) inc.addEventListener('click', function () { qtyInput.value = qty() + 1; updateUI(); });
    if (qtyInput) qtyInput.addEventListener('input', updateUI);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = currentVariant();
      if (!v || !v.available) return;
      if (addBtn) addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: qty() }] })
      }).then(function (r) { return r.json(); }).then(function () {
        if (addBtn) addBtn.disabled = false;
        if (window.fdCart) window.fdCart.open();
      }).catch(function () { if (addBtn) addBtn.disabled = false; });
    });

    updateUI();
  }

  /* ---------- Collection filter (client-side) ---------- */
  function initFilter() {
    var wrap = document.querySelector('[data-fd-filter]');
    var grid = document.querySelector('[data-fd-filter-grid]');
    if (!wrap || !grid) return;
    wrap.querySelectorAll('[data-fd-filter-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        wrap.querySelectorAll('[data-fd-filter-btn]').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
        var f = btn.getAttribute('data-filter');
        grid.querySelectorAll('[data-type]').forEach(function (tile) {
          tile.style.display = (f === 'all' || tile.getAttribute('data-type') === f) ? '' : 'none';
        });
      });
    });
  }

  function initChoice() {
    document.querySelectorAll('[data-fd-choice]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-fd-choice-input]');
      wrap.querySelectorAll('[data-fd-choice-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var active = btn.classList.contains('is-active');
          wrap.querySelectorAll('[data-fd-choice-btn]').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
          if (active) {
            if (input) input.value = '';
          } else {
            btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
            if (input) input.value = btn.getAttribute('data-value') || btn.textContent.trim();
          }
        });
      });
    });
  }

  function initCarousel() {
    document.querySelectorAll('[data-fd-carousel]').forEach(function (c) {
      var slides = c.querySelectorAll('[data-fd-slide]');
      if (slides.length < 2) return;
      var dots = c.querySelectorAll('[data-fd-carousel-dot]');
      var idxEl = c.querySelector('[data-fd-carousel-index]');
      var cur = 0;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function show(i) {
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, si) { s.classList.toggle('is-active', si === cur); });
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === cur); });
        if (idxEl) idxEl.textContent = pad(cur + 1) + ' / ' + pad(slides.length);
      }
      var prev = c.querySelector('[data-fd-carousel-prev]');
      var next = c.querySelector('[data-fd-carousel-next]');
      if (prev) prev.addEventListener('click', function () { show(cur - 1); });
      if (next) next.addEventListener('click', function () { show(cur + 1); });
      dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-idx'), 10)); }); });
      var stage = c.querySelector('.fd-pgallery__stage') || c;
      addSwipe(stage, function () { show(cur + 1); }, function () { show(cur - 1); });
    });
  }

  function init() {
    document.body.classList.add('fd-body');
    initReveal();
    initHero();
    initNav();
    initDrawer();
    initQuickAdd();
    initAccordion();
    initProduct();
    initFilter();
    initChoice();
    initCarousel();
    initCartPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
